import { TeardownLogic } from 'rxjs';
import { AuthService } from './auth.service';

export function appInitializer(authService: AuthService)
{
    return () =>
        new Promise((resolve) =>
        {
            authService.refreshToken().subscribe().add(resolve as TeardownLogic);
        });
}